export const PAGE_MODES = [
  {
    label : "작성",
    value : "create"
  },
  {
    label : "수정",
    value : "modify"
  },
  {
    label : "상세",
    value : "view"
  }
]